import React, { useRef, useEffect, useState } from "react";
import { useScreenWidth } from "../../hooks/useScreenWidth";

function calculateMaxFontSize(screenWidth, minFontSize, containerRef, textRef) {
  if (!containerRef?.current || !textRef?.current) return minFontSize;

  const maxFontSize = screenWidth > 500 ? 1.75 : 1.25;

  let size = maxFontSize;
  textRef.current.style.fontSize = `${size}vw`;

  if (!textRef.current.scrollWidth && !textRef.current.offsetWidth) {
    return minFontSize;
  }

  while (
    (textRef.current.scrollWidth || textRef.current.offsetWidth) >
      containerRef.current.clientWidth &&
    size > minFontSize
  ) {
    size -= 0.01;
    textRef.current.style.fontSize = `${size}vw`;
  }

  return size;
}

const AutoFitText = ({ children, minFontSize = 0.75, debug = false }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const screenWidth = useScreenWidth();
  const [fontSize, setFontSize] = useState(
    calculateMaxFontSize(screenWidth, minFontSize, containerRef, textRef),
  );

  useEffect(() => {
    if (textRef.current) {
      setFontSize(
        calculateMaxFontSize(screenWidth, minFontSize, containerRef, textRef),
      );
    }
  }, [screenWidth, minFontSize]);

  return (
    <div ref={containerRef} style={{ overflow: "hidden", width: "100%" }}>
      <span
        ref={textRef}
        style={{
          fontSize: `${fontSize}vw`,
          whiteSpace: "nowrap",
        }}>
        {children}
      </span>
    </div>
  );
};

export default AutoFitText;
